import { keywordWidth } from './constants';
import { interpolateBlues } from 'd3-scale-chromatic';
import { FaKey } from 'react-icons/fa';
import PropTypes from 'prop-types';
import React from 'react';

const CollapsedGroup = ({
  startY,
  cluster,
  toggleCollapsed,
  keywords,
  selectedColumn,
  setSelectedColumn,
  keywordsInCluster
}) => {
  return (
    <>
      <g transform={`translate(0, ${10})`}>
        {/* square showing term frequency in document */}
        {keywordsInCluster &&
          keywordsInCluster[cluster.id] &&
          Object.keys(keywordsInCluster[cluster.id]).map((word) => {
            const keyword_index = keywords.indexOf(word);

            if (keyword_index === -1) {
              return null;
            }

            const x = keyword_index * keywordWidth;

            return (
              <React.Fragment key={word}>
                <circle
                  key={`${word}-title-${cluster.id}-${keyword_index}`}
                  cx={x + keywordWidth / 2}
                  cy={startY + keywordWidth / 2}
                  r={keywordWidth / 2}
                  fill={interpolateBlues(
                    keywordsInCluster[cluster.id][word] / cluster.members.length
                  )}
                  stroke={selectedColumn === word ? 'gold' : 'lightgrey'}
                  strokeWidth={selectedColumn === word ? '3' : '1'}
                  onMouseOver={() => {
                    setSelectedColumn(word);
                  }}
                  onMouseOut={() => {
                    setSelectedColumn(null);
                  }}
                  onClick={toggleCollapsed}
                >
                  <title>
                    {keywordsInCluster[cluster.id][word]}/
                    {cluster.members.length} documents in this cluster contain
                    &quot;{word}&quot; - click to expand.
                  </title>
                </circle>

                {cluster.keywords.includes(word) && (
                  <g transform={`translate(${x + 4}, ${startY + 4})`}>
                    <FaKey
                      color="#f28e2c"
                      size="0.8em"
                      onMouseOver={() => {
                        setSelectedColumn(word);
                      }}
                      onMouseOut={() => {
                        setSelectedColumn(null);
                      }}
                      onClick={toggleCollapsed}
                    />
                  </g>
                )}
              </React.Fragment>
            );
          })}
      </g>
    </>
  );
};
CollapsedGroup.propTypes = {
  startY: PropTypes.number,
  startCol: PropTypes.number,
  cluster: PropTypes.shape({
    members: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    keywords: PropTypes.arrayOf(PropTypes.string),
    labels: PropTypes.string,
    id: PropTypes.number
  }),
  toggleCollapsed: PropTypes.func,
  tdMatrix: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  matrixWidth: PropTypes.number,
  keywords: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedColumn: PropTypes.string,
  setSelectedColumn: PropTypes.func.isRequired,
  keywordsInCluster: PropTypes.object
};

export default CollapsedGroup;
